import * as React from "react"

import { cn } from "@/lib/utils"

/* Inndatafelt: 44 px på mobil (16 px tekst hindrer zoom i iOS), 40 px og 15 px tekst fra lg. */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-11 w-full rounded-[10px] border border-[var(--hr-border)] bg-white px-3 py-2 text-base leading-6 shadow-none transition-[border-color,box-shadow] duration-150 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[var(--hr-muted-2)] hover:border-[rgba(31,33,48,0.28)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-[var(--hr-red)] lg:h-10 lg:text-[15px]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
